import React,{useRef,useEffect} from 'react';   
import {
    Button,
    Container,
    Divider,
    Grid,
    Header,
    Icon,
    Image,
    List,
    Menu,
    Responsive,
    Segment,
    Sidebar,
    Visibility,
  } from 'semantic-ui-react'
  import HomePageCell from './HomePageCell'
function CheckItOut(props)
{
   return <Grid celled='internally' columns='equal' stackable>
    <Grid.Row textAlign='center'>
    {props.hiddenButton === 'interactive' ? null :<HomePageCell 
        title="Interactive Gameplay" 
        body="Stop opponents from committing actions, push characters into or away from harm, change the target of opponent's actions!"
        destination="/interactive"
        minigif = "./minigif/DragonIdle.gif"
      ></HomePageCell> }
      {props.hiddenButton === 'abilities' ? null :<HomePageCell 
        title="Interesting Abilities that Redefine the Tactical RPG" 
        body="Teleport between wargates you create, divide the terrain in two with an earthquake, freeze the floor and slide around!"
        destination="/abilities"
        minigif = "./minigif/PaladinCharge.gif"
      >
      </HomePageCell>}
      {props.hiddenButton === 'dualclass' ? null : <HomePageCell 
      title="Dual-Class System" 
      body="Each character has two classes and abilities combine in interesting ways!"
      destination="/dualclass" 
      minigif = "./minigif/SentinelBlock.gif"
      ></HomePageCell>}
    </Grid.Row>
  </Grid>
}

export default CheckItOut